module.exports = __webpack_public_path__ + "img/img-floor-2f.56a57c6d.png";